/**
 * Dates of the dealership's calendar. Rental reservations, odometer readings and checks are defined in Prague
 * local time (the API judges "today" there), so a form's default or a `max` must not follow the BROWSER's zone:
 * an operator abroad, or a browser set to another zone, would otherwise send the previous or the next day around
 * midnight.
 */

/** Today in Prague as `YYYY-MM-DD`. */
export function pragueToday(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Prague' }).format(now);
}

/** Now in Prague as `YYYY-MM-DD HH:mm` — the form the API stores reservation times in. */
export function pragueNowLocal(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(now);
}

/** `YYYY-MM-DD` + n calendar days (pure date arithmetic, no zone). */
export function addDays(day: string, n: number): string {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}
